module.exports = __webpack_public_path__ + "static/img/12.ab4a34f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/12.png
// module id = nTUR
// module chunks = 0